import { Translations } from '../types';

export const pt: Translations = {
  common: {
    loading: 'Carregando...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Salvar',
    delete: 'Excluir',
    edit: 'Editar',
    back: 'Voltar',
    next: 'Próximo',
    submit: 'Enviar',
    search: 'Pesquisar',
    filter: 'Filtrar',
    all: 'Todos',
    viewAll: 'Ver Tudo',
    copy: 'Copiar',
    copied: 'Copiado!',
    success: 'Sucesso',
    error: 'Erro',
    close: 'Fechar',
  },
  nav: {
    home: 'Início',
    linkExchange: 'Vincular Exchange',
    rebate: 'Reembolso',
    exchanges: 'Exchanges',
    withdraw: 'Sacar',
    history: 'Histórico',
    checkIn: 'Check In',
    profile: 'Perfil',
    overview: 'Visão Geral',
    rewardHub: 'Centro de Recompensas',
    settings: 'Configurações',
  },
  dashboard: {
    title: 'Bem-vindo, {name}!',
    subtitle: 'Visão geral da sua conta',
    balance: 'Saldo',
    totalEarned: 'Total Ganho',
    pendingRebate: 'Reembolso Pendente',
    availablePoints: 'XP Disponível',
    recentRebates: 'Reembolsos Recentes',
    recentWithdrawals: 'Saques Recentes',
  },
  linkExchange: {
    title: 'Vincular Conta de Exchange',
    subtitle: 'Conecte seu UID de exchange para habilitar o rastreamento automático de taxas',
    exchange: 'Exchange',
    uid: 'UID',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    linkAccount: 'Vincular Conta',
    linkedAccounts: 'Contas Vinculadas',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    delete: 'Excluir Conta',
    selectExchange: 'Selecionar Exchange',
    enterUID: 'Digite o UID',
    enterApiKey: 'Digite a API Key',
    enterApiSecret: 'Digite o API Secret',
    accountLinked: 'Conta vinculada com sucesso',
    accountDeleted: 'Conta excluída com sucesso',
    binance: 'Binance',
    bybit: 'Bybit',
    okx: 'OKX',
    gate: 'Gate.io',
  },
  rebate: {
    title: 'Reembolso de Taxas de Trading',
    subtitle: 'Histórico de pagamentos de reembolso automático',
    totalRebate: 'Reembolso Total',
    pendingRebate: 'Reembolso Pendente',
    balance: 'Saldo',
    withdraw: 'Sacar',
    rebateHistory: 'Histórico de Reembolsos',
    date: 'Data',
    amount: 'Quantia',
    status: 'Status',
    completed: 'Concluído',
    pending: 'Pendente',
    failed: 'Falhou',
    description: 'Descrição',
    autoRebate: 'Reembolso Automático',
    autoRebateDesc: 'O sistema reembolsará automaticamente as taxas de trading para sua conta. Tempo de processamento: 1-3 dias úteis.',
  },
  withdraw: {
    title: 'Sacar',
    subtitle: 'Sacar fundos para sua carteira',
    availableBalance: 'Saldo Disponível',
    withdrawAmount: 'Quantia a Sacar',
    walletAddress: 'Endereço da Carteira (ou UID)',
    network: 'Rede',
    selectNetwork: 'Selecionar Rede',
    enterAmount: 'Digite a quantia',
    enterWalletAddress: 'Digite o endereço da carteira (ou UID)',
    withdraw: 'Sacar',
    minWithdraw: 'Saque mínimo: {amount}',
    fee: 'Taxa',
    receiveAmount: 'Você receberá',
    withdrawHistory: 'Histórico de Saques',
    processing: 'Processando',
    completed: 'Concluído',
    failed: 'Falhou',
    trc20: 'TRC20',
    erc20: 'ERC20',
    bep20: 'BEP20',
    pleaseEnterAmount: 'Por favor, digite uma quantia válida',
    pleaseEnterWallet: 'Por favor, digite o endereço da carteira',
    pleaseSelectNetwork: 'Por favor, selecione uma rede',
    invalidAmount: 'Quantia inválida',
    amountTooLow: 'Quantia abaixo do saque mínimo',
    insufficientBalance: 'Saldo insuficiente',
    confirmWithdrawal: 'Confirmar Saque',
    withdrawalSubmitted: 'Solicitação de saque enviada com sucesso! Verifique o Histórico para ver o status.',
    withdrawalFailed: 'Saque falhou',
    note: 'Nota',
    withdrawalNote: 'As taxas de gas serão deduzidas da quantia do saque',
  },
  history: {
    title: 'Histórico de Transações',
    subtitle: 'Ver todas as suas transações e saques',
    transactions: 'Transações',
    withdrawals: 'Saques',
    rebates: 'Reembolsos',
    date: 'Data',
    type: 'Tipo',
    amount: 'Quantia',
    status: 'Status',
    noTransactions: 'Nenhuma transação encontrada',
    noWithdrawals: 'Nenhum saque encontrado',
    noRebates: 'Nenhum reembolso encontrado',
    claimNow: 'Resg Agora',
    claiming: 'Resgatando...',
    readyToClaim: 'Pronto para reivindicar do contrato inteligente',
    claimedSuccessfully: 'Reivindicado com sucesso!',
    failedToClaim: 'Falha ao reivindicar',
    noMoreItems: 'Não há mais itens',
    payGas: 'Pagar Gas',
    claimed: 'Reivindicado',
    noHistoryFound: 'Nenhum histórico encontrado',
    statusCompleted: 'Concluído',
    statusPending: 'Pendente',
    statusFailed: 'Falhou',
    statusProcessing: 'Processando',
    statusRejected: 'Rejeitado',
  },
  checkIn: {
    title: 'Check In Diário',
    subtitle: 'Faça check in diariamente para ganhar pontos',
    checkIn: 'Check In',
    checkedIn: 'Check In Feito',
    todayPoints: 'XP de Hoje',
    totalPoints: 'XP Total',
    points: 'XP',
    redeem: 'Resgatar',
    rewards: 'Recompensas',
    vouchers: 'Vouchers',
    linkReward: 'Recompensa por Vincular',
    linkExchange: 'Vincular Conta de Exchange',
    linkRewardDesc: 'Vincule sua conta de exchange para receber pontos de bônus',
    rewardHistory: 'Histórico de Recompensas',
    availableRewards: 'Recompensas Disponíveis',
    voucher: 'Voucher',
    gift: 'Presente',
    pointsRequired: 'XP Necessário',
    redeemNow: 'Resgatar Agora',
    redeemed: 'Resgatado',
    noRewards: 'Nenhuma recompensa disponível',
    shop: 'Loja',
    myCodes: 'Meus Códigos',
    backButton: '← Voltar',
    noPointsHistory: 'Sem histórico de XP',
    myRedeemedCodes: 'Meus Códigos Resgatados',
    yourCode: 'Seu Código:',
    codeCopied: '¡Código copiado!',
    noRedeemedYet: 'Ainda não há recompensas resgatadas',
    dailyCheckIn: 'Check In Diário',
    tasks: 'Tarefas',
    checkedInSuccessfully: 'Check in bem-sucedido!',
    checkInFailed: 'Check in falhou',
    claimedTask: 'Tarefa reivindicada com sucesso!',
    failedToClaimTask: 'Falha ao reivindicar tarefa',
    insufficientPoints: 'XP insuficiente',
    redeemFailed: 'Resgate falhou',
    special: 'Especial',
    social: 'Social',
    trading: 'Trading',
    watchAd: 'Assistir Anúncio',
    available: 'disponível',
    completed: 'concluído',
    comingSoon: 'Em Breve',
    times: 'vezes',
    weeklyLeaderboard: 'Ranking XP Semanal',
    leaderboardSubtitle: 'Melhores desempenhos desta semana',
    yourRank: 'Sua Posição',
    yourXP: 'Seu XP',
    you: 'Você',
    noLeaderboardData: 'Ainda não há dados do ranking',
    prize: 'Prêmio',
  },
  profile: {
    title: 'Perfil',
    accountInfo: 'Informações da Conta',
    telegramId: 'Telegram ID',
    joinDate: 'Data de Registro',
    language: 'Idioma',
    english: 'Inglês',
    vietnamese: 'Vietnamita',
    spanish: 'Espanhol',
    portuguese: 'Português',
    chinese: 'Chinês',
    indonesian: 'Indonésio',
    emailSettings: 'Configurações de Email',
    notSet: 'Não configurado',
    logout: 'Sair',
    logoutConfirm: 'Tem certeza de que deseja sair?',
  },
  login: {
    title: 'CashBackHub',
    subtitle: 'Sistema de Reembolso de Taxas de Trading',
    description: 'Telegram Mini App',
    hint: 'Por favor, abra o aplicativo pelo Telegram',
    login: 'Entrar',
  },
  exchanges: {
    title: 'Exchanges',
    subtitle: 'Escolha seu tipo de indicação',
    chooseReferralType: 'Escolha seu tipo de indicação',
    exchangeReferral: 'Indicação de Exchange',
    linkYourUid: 'Vincule seu UID',
    copyTrade: 'Copy Trade',
    followTrades: 'Siga nossas operações',
    filterByExchange: 'Filtrar por exchange:',
    allExchanges: 'Todos os Exchanges',
    accounts: 'conta(s)',
    account: 'Conta',
    connected: 'Conectado',
    uidCopied: 'UID copiado!',
    totalRebate: 'Reembolso Total',
    transactionVolume: 'Volume de Transações',
    waitingForSync: 'Aguardando sincronização',
    cashbackHubRebate: 'Reembolso CashbackHub',
    viewReason: 'Ver Motivo',
    reconnect: 'Reconectar',
    noAccounts: 'Ainda não há contas de exchange',
    rejectionReason: 'Motivo da Rejeição',
    exchangeConnected: 'Exchange conectado com sucesso!',
    notConfigured: 'Ainda não configurado',
    noExchangesAvailable: 'Não Há Exchanges Disponíveis',
    pleaseContactSupport: 'Por favor, entre em contato com nossa equipe de suporte para configurar exchanges para sua conta.',
    allAccounts: 'Todas',
    activeAccounts: 'Ativas',
    pendingAccounts: 'Pendentes',
    rejectedAccounts: 'Rejeitadas',
    totalProfit: 'Lucro Total',
    noCopyTradeAccounts: 'Ainda não há contas de copy trade',
    rejectionReasonText: 'Este UID não foi registrado em nosso sistema de indicações. Por favor, entre em contato com nossa equipe de suporte @backcashhub para obter instruções detalhadas sobre como concluir o processo de registro!',
  },
  settings: {
    title: 'Configurações',
    subtitle: 'Personalize sua experiência e gerencie os detalhes da sua conta',
    telegramNotifications: 'Notificações do Telegram',
    profile: 'Perfil',
    telegramNotificationsDesc: 'Receba atualizações instantâneas via Telegram',
    uid: 'UID',
    connected: 'Conectado',
    connect: 'Conectar',
    emailVerification: 'Verificação de Email',
    emailAddress: 'Endereço de Email',
    sendVerificationCode: 'Enviar Código de Verificação',
    sending: 'Enviando...',
    verificationCode: 'Código de Verificação',
    enterCode: 'Digite o código de 6 dígitos do seu email',
    changeEmail: 'Mudar Email',
    resendCode: 'Reenviar Código',
    verifying: 'Verificando...',
    verifyEmail: 'Verificar Email',
    codeExpired: 'O código de verificação expirou. Por favor, solicite um novo.',
    invalidCode: 'Código de verificação inválido. Por favor, tente novamente.',
    verificationSent: 'Código de verificação enviado com sucesso! Verifique seu email.',
    emailVerified: 'Email verificado com sucesso!',
    failedToSend: 'Falha ao enviar o código de verificação. Por favor, tente novamente.',
    failedToVerify: 'Falha ao verificar o email. Por favor, tente novamente.',
    enterEmailPlaceholder: 'seu.email@example.com',
    enterCodeDesc: 'Digite o código de 6 dígitos do seu email',
  },
  copyTrade: {
    title: 'Copy Trade',
    notConfigured: 'Ainda não configurado',
    noExchangesAvailable: 'Não Há Exchanges Disponíveis',
    pleaseContactSupport: 'Por favor, entre em contato com nossa equipe de suporte para configurar exchanges para sua conta.',
    linkCopyTradeAccount: 'Vincular Conta de Copy Trade',
    selectExchange: 'Selecionar Exchange',
    step1: 'Passo 1: Clique no botão abaixo para copy trade',
    openCopyTradeLink: 'Abrir Link de Copy Trade',
    clickToCopyTrade: 'Clique para abrir nosso link de copy trade e siga as instruções',
    step2: 'Passo 2: Digite Seu UID',
    enterYourUid: 'Digite Seu UID',
    enterUidPlaceholder: 'Digite seu UID no exchange',
    submit: 'Enviar',
    submitting: 'Enviando...',
    pleaseEnterUid: 'Por favor, digite seu UID',
    pleaseSelectExchange: 'Por favor, selecione um exchange',
    pleaseSelectBot: 'Por favor, selecione um bot',
    submittedSuccessfully: 'Conta de copy trade enviada com sucesso! Aguarde a aprovação.',
    accountRejectedPleaseResubmit: 'Sua conta foi rejeitada. Por favor, reenvie com informações corretas.',
    disabled: 'Desabilitado',
    accountDisabledMessage: 'Esta conta foi desabilitada. Por favor, entre em contato com o suporte para mais informações.',
    submitFailed: 'Falha ao enviar conta de copy trade',
  },
  rules: {
    title: 'Regras de Reembolso',
    description: 'Percentual de reembolso baseado em marcos de lucro:',
    profitRange: 'Faixa de Lucro',
    rebatePercentage: 'Reembolso',
    range1: '$100 - $200',
    range2: '$201 - $300',
    range3: '$301 - $400',
    range4: '$500+',
    note: 'O reembolso é calculado com base no lucro incremental após a dedução do reembolso da exchange.',
    noRules: 'Nenhuma regra de reembolso disponível',
  },
};

